import { render } from "./as-textWithLabel.vue?vue&type=template&id=08ebccfc&scoped=true&ts=true"
import script from "./as-textWithLabel.vue?vue&type=script&lang=ts"
export * from "./as-textWithLabel.vue?vue&type=script&lang=ts"

import "./as-textWithLabel.vue?vue&type=style&index=0&id=08ebccfc&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\src\\WebUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08ebccfc"]])

export default __exports__